import React,{useEffect,useState} from 'react';
import Alert from '@mui/material/Alert';
import api from '@src/api/axiosInstance';
import {WakymaDraft} from '@src/helpers/WakymaDraft';

export default function WakymaCaptureNotice({draft,onClose}:{draft:WakymaDraft;onClose:()=>void}){
 const [status,setStatus]=useState('Guardando para revisión…');
 const [retry,setRetry]=useState(0);
 useEffect(()=>{
  let active=true;setStatus('Guardando para revisión…');
  api.post('/wakyma-captures/',{phone:draft.phone,at:draft.at,text:draft.originalText||''}).then(()=>{if(active)setStatus('Registrado para revisión.');}).catch(()=>{if(active)setStatus('No se ha podido registrar.');});
  return ()=>{active=false;};
 },[draft.phone,draft.at,retry]);
 return <Alert severity="info" onClose={onClose} style={{margin:'8px 16px',flexShrink:0}}>
  <strong>Formato de Wakyma sin plantilla</strong>
  <div>Hemos abierto la conversación. No se ha enviado ningún mensaje.</div>
  <small>{status}</small>{status==='No se ha podido registrar.' && <button type="button" onClick={()=>setRetry(n=>n+1)}>Reintentar</button>}
  {draft.originalText && <details><summary>Ver texto de Wakyma</summary><div style={{whiteSpace:'pre-wrap',overflowWrap:'anywhere',maxHeight:160,overflowY:'auto'}}>{draft.originalText}</div></details>}
 </Alert>;
}
